import type { LegalForm } from "./types";

/*
 * The German names of the legal forms, in the order of the core customer
 * model RFC. smarta-accounts owns the list; until it serves the labels too,
 * the Backoffice keeps them here, next to the generated enum they must match.
 */
export const LEGAL_FORM_LABELS: Record<LegalForm, string> = {
  PRIVATE_INDIVIDUAL: "Privatperson",
  SOLE_PROPRIETOR: "Einzelunternehmer",
  REGISTERED_SOLE_TRADER: "e. K.",
  CIVIL_PARTNERSHIP: "GbR",
  PROFESSIONAL_PARTNERSHIP: "Partnerschaft (nach PartGG)",
  GENERAL_PARTNERSHIP: "OHG",
  LIMITED_PARTNERSHIP: "KG",
  GMBH: "GmbH",
  UG: "UG (haftungsbeschränkt)",
  GMBH_AND_CO_KG: "GmbH und Co. KG",
  KGAA: "KGaA",
};

export const LEGAL_FORM_OPTIONS = (
  Object.entries(LEGAL_FORM_LABELS) as [LegalForm, string][]
).map(([value, label]) => ({ value, label }));
